/* global angular, jQuery */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.directive('newsKeystat', ['Api', 'AjaxList', '$compile',
    function (Api, AjaxList, $compile) {
        return {
            restrict: 'A',
            scope: {observation: '@'},
            templateUrl: null,
            link: function (scope, element) {
                scope.loadKS = function() {
                    scope.news_ks = new AjaxList(Api.content.news_keystat);
                    scope.news_ks.loadNext({observation: scope.observation}).then(function (data) {
                        if (data.length === 0){
                            element.hide();
                        }
                        else if (data.length === 1) {
                            $('.news-keystats .add-to-pptbuilder').first().css('display', 'none');
                        } else {
                            var elem = $('.grey-background').attr('data-add-to-ppt-hover', 'data-add-to-ppt-hover');
                            $compile(angular.element(elem))(scope);
                        }
                    });
                };
                scope.loadKS();
            }
        };
    }
]);
